import React from 'react'
import SampleBanner from '../../components/sampleComponents/sampleBanner/SampleBanner'
import Header from '../../components/Navbar/Header'
import Footer from '../../components/Footer/Footer'
import SampleSignInForm from '../../components/sampleComponents/sampleSignInForm/SampleSignInForm'
import SecondHeader from '../../components/SecondHeader/SecondHeader'

const SampleSIgnIn = () => {
    return (
        <>
            {/* <Header /> */}
            <SecondHeader/>
            <SampleBanner />
            <SampleSignInForm />
            <Footer />
        </>
    )
}

export default SampleSIgnIn